// extracted by mini-css-extract-plugin
export var lastUpdatedChip = "F_b2";
export var legalWrapper = "F_b1";